import { useLocalObservable } from 'mobx-react-lite';
import { ReactNode } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { CallEventTypes } from '@gem/call/constants';
import dateService from '@gem/services/date-service';

import { RiseHand } from './components/RiseHand/RiseHand';

interface IItem {
  text: ReactNode;
  timestamp: number;
}

interface IEventsBarPresenter {
  lastEvent: number;
  setLastEvent(timestamp: number): void;
  items: IItem[];
  ongoingCall: Call;
}

export const useEventsBarPresenter = (): IEventsBarPresenter => {
  const context = useCallContext();

  const presenter = useLocalObservable<IEventsBarPresenter>(() => ({
    lastEvent: +dateService.now(),

    get ongoingCall(): Call {
      return context.call;
    },

    get items(): IItem[] {
      const call = presenter.ongoingCall;
      const list = call.events.list;
      const filteredList = list.filter((data) => data.timestamp > presenter.lastEvent);
      const eventItems = filteredList.map((data) => {
        let text: ReactNode = '';
        switch (data.type) {
          case CallEventTypes.RaiseHand: {
            text = (
              <RiseHand
                avatarColorIndex={data.avatarColorIndex}
                avatarUrl={data.avatarUrl}
                displayName={data.displayName}
              />
            );
            break;
          }
          default:
            text = data.text;
        }

        return { text, timestamp: data.timestamp };
      });

      // ToDO - need to refactor after rewriting Events store to TS
      return eventItems.filter((item) => item !== null) as IItem[];
    },

    setLastEvent(timestamp: number): void {
      presenter.lastEvent = timestamp;
    },
  }));

  return presenter;
};
